import CssBaseline from '@mui/material/CssBaseline';
import { ThemeProvider } from '@mui/material/styles';
import { useEffect } from 'react';
import { Provider } from 'react-redux';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import AuthProvider from './components/AuthProvider';
import { ToastProvider, ToastInitializer } from './components/common/Toast';
import { CompanyProvider } from './contexts/CompanyContext';
import routes from './routes';
import { store } from './store';
import theme from './theme';
import { initializeAppAuthService } from './services/appAuthService';

// basename '/admin' is required for both dev and production.
// In production the ingress routes /admin/* → this service; React Router
// receives the full path and needs basename to strip the mount prefix before
// matching routes (e.g. /admin/callback → callback).
const router = createBrowserRouter(routes, { basename: '/admin' });

function App() {
  // Remove the loading state once the app is initialized
  useEffect(() => {
    const loader = document.getElementById('app-loader');
    if (loader) {
      loader.style.display = 'none';
    }

    // Restore any still-valid extended token and (re)arm the background
    // refresh timer on page load/reload — mirrors the tenant frontend so a
    // reload doesn't leave the refresh-within-5-minutes check dormant until
    // the token has already expired.
    initializeAppAuthService();
  }, []);

  return (
    <AuthProvider>
      <Provider store={store}>
        <ToastProvider>
          <ToastInitializer />
          <CompanyProvider>
            <ThemeProvider theme={theme}>
              <CssBaseline />
              {/* <NotificationWebSocketProvider> */}
                <RouterProvider router={router} />
              {/* </NotificationWebSocketProvider> */}
            </ThemeProvider>
          </CompanyProvider>
        </ToastProvider>
      </Provider>
    </AuthProvider>
  );
}

export default App;
